
import { Component, Vue } from 'vue-property-decorator';

@Component
export default class WorkCarouselYouTube extends Vue {
  mediaWidth = 1200;
  mediaHeight = 710;
  private currentSlide = 1;
  private totalSlides?: number;

  mounted() {
    const slidesContainer = this.$refs.slidesContainer as HTMLElement;
    this.totalSlides = slidesContainer.querySelectorAll('figure').length;
    slidesContainer.querySelectorAll('figure').forEach((slide) => {
      slide.style.width = slidesContainer.offsetWidth + 'px';
    });

    // Uses the dimensions of the first image to set the width and height
    // for the video iframe YouTube embed
    const firstImageEl = this.$refs.firstImageEl as HTMLImageElement;
    firstImageEl.addEventListener('load', () => {
      this.mediaWidth = firstImageEl.clientWidth;
      this.mediaHeight = firstImageEl.clientHeight;
    });
  }

  getCurrentSlide() {
    return this.currentSlide;
  }

  getLastSlide() {
    return this.totalSlides;
  }

  setPreviousSlide(event: Event) {
    this.currentSlide = this.getCurrentSlide() - 1;
    this.navigateToSlide(event);
  }

  setNextSlide(event: Event) {
    this.currentSlide = this.getCurrentSlide() + 1;
    this.navigateToSlide(event);
  }

  navigateToSlide(event: Event) {
    const currentSlideEl = document.getElementById(
      'slide-' + this.currentSlide,
    );
    currentSlideEl!.scrollIntoView({
      // behavior: 'smooth',
      block: 'nearest',
      inline: 'center',
    });
  }

  navigateTo(route: string) {
    this.$router.push(route);
  }
}
